import fp from "lodash/fp";
import moment from "moment";

import { deleteEmptyValues } from "mappers";
import { PaymentTypes } from "types";

import {
	accountNumberFieldName,
	bankAccountFieldName,
	bankFieldName,
	cardHolderNameFieldName,
	cardNumberFieldName,
	cardTypeFieldName,
	cvvFieldName,
	expirationDateFieldName,
	payeeFirstNameFieldName,
	payeeLastNameFieldName,
	paymentMethodStatusFieldName,
	paymentTypeFieldName,
	routingNumberFieldName,
} from "./paymentMethodConstants";

export const getMappedPaymentMethodForm = formValues => {
	return fp.flow(formValues => {
		const [month, year] = formValues?.[expirationDateFieldName]
			? moment(`${formValues?.[expirationDateFieldName]}`, "MM:YY")
					.format("MM YYYY")
					.split(" ")
			: [];

		const { value: paymentMethod }: any = PaymentTypes.getByValue(
			formValues?.[paymentTypeFieldName]?.value,
		);

		const isAchPaymentMethod = paymentMethod === PaymentTypes.ach.value;
		const isCreditCardPaymentMethod =
			paymentMethod === PaymentTypes.creditCard.value;

		const mappedValues = {
			payment_type: formValues?.[paymentTypeFieldName]?.value || null,
			is_active: formValues?.[paymentMethodStatusFieldName] || null,
			ach: isAchPaymentMethod
				? {
						account_number:
							formValues?.[accountNumberFieldName] || null,
						bank_account_name:
							formValues?.[bankAccountFieldName] || null,
						bank_name: formValues?.[bankFieldName] || null,
						routing_number:
							formValues?.[routingNumberFieldName]?.value || null,
				  }
				: null,
			credit_card: isCreditCardPaymentMethod
				? {
						network: formValues?.[cardTypeFieldName] || null,
						holder_name:
							formValues?.[cardHolderNameFieldName] || null,
						number: formValues?.[cardNumberFieldName] || null,
						expiration_month: month || null,
						expiration_year: year || null,
						cvv: formValues?.[cvvFieldName] || null,
				  }
				: null,
			payee_first_name: formValues?.[payeeFirstNameFieldName],
			payee_last_name: formValues?.[payeeLastNameFieldName],
		};

		return mappedValues;
	}, fp.tap(deleteEmptyValues))(formValues);
};
